//土耳其语
export default {
	default:{
		submit:"Gönder",
		SendVerificationCode:"Doğrulama kodu gönder",
		VerificationCode:"Doğrulama Kodu",
		VerificationCodeTip:"Lütfen doğrulama kodunu giriniz",
		MessageAuthenticationCode:"Doğrulama mesaj kodu",
		EmailAuthenticationCode:'Doğrulama Email kodu',
		VerificationCodeError:'Yanlış doğrulama kodu',
		PasswordsNotMatch:"Şifreler eşleşmiyor",
		PasswordChangeSuccess:"şifre değiştirildi",
		PasswordError:"Yanlış parola",
		CNY:'CNY',
		USD:'USD',
		TRY:'TRY',
		Notice:"Hatırlatma",
		Done:'Evet',
		ErrorSendingEmail:'E-posta doğrulama kodunu gönderirken hata oluştu, lütfen e-postanızı kontrol edin.',
		SuccessSendingEmail:'E-posta doğrulama kodu gönderildi, lütfen kontrol edin.',
		ErrorSendingMessage:'Mesaj doğrulama kodunu gönderirken hata oluştu, lütfen telefon numaranızı kontrol edin.',
		SuccessSendingMessage:'Mesaj doğrulama kodu gönderildi, lütfen kontrol edin.',
		Resend:'Yeniden Gönder',
		EmailCodeErr:'E-posta doğrulama kodu hatası',
		ImgCodeErr:'Görüntü doğrulama kodu hatası',
		MessageCodeErr:'SMS doğrulama kodu hatası'
	},
	nav:{
		UserCenter:'Kullanıcı Merkezi',
		MyAccount:'Hesabım',
		SecurityCenter:'Güvenlik Merkezi',
		ChangePassword:'Şifreyi Değiştir',
		RealNameAuthentication:'Kimlik Doğrulama',
		Phone:'Telefon ile bağlan ve değiştir',
		Email:'Email göndererek değiştir',
		SecurityQuestion:'Güvenlik Sorusu',
		VoucherCenter:'Kupon Merkezi',
		GameRecharge:'Tekrar Doldur',
		RechargeHistory:'Yeniden doldurma geçmişi',
		AccountComplaint:'Hesap şikayeti',
		ThirdAccount:'Diğer Girişler'
	},
	header:{
		Login:"Giriş",
		Logout:"Çıkış",
		GameLists:"Oyun Listeleri",
		UserCenter:"Kullanıcı Merkezi",
		SecurityCenter:"Güvenlik Merkezi",
		VoucherCenter:"Kupon Merkezi ",
		CustomerServiceCenter:"Müşteri Destek",
		Language:"Dil",
		CurrentPosition:"Geçerli Konum",
	},
	games:{
		battleTeams1:"battleTeams1",
		battleTeams2:"battleTeams1", 
		battleTeamsMobile:"battleTeamsMobile",
	},
	home:{
		AccountInformation:"Hesap Bilgileri",
		UserName:"Kullanıcı Adı",
		Nickname:"Nick Name",
		TheLatestLoginDate:"Son Giriş Tarihi",
		SecurityLevel:"Güvenlik Düzeyi",
		SecurityTip:"Hesabınızın Güvenliği İçin, ayarları takip etmenizi öneriyoruz",
		Change:"Değiştir",
		Bind:"Bağla",
		Setting:"Ayar",
		Submitted:"Gönderildi",
		Bound:"Bağla",
		Set:"Kuruldu",
		Unsubmitted:"Gönderilmedi",
		Unbound:"Bağlanmadı",
		Notset:"Kurulmadı",
		PasswordLevel:"Şifre Düzeyi",
		Security:"Güvenlik",
		SecurityLow:'Normal',
		SecurityHigh:'Yüksek',
		PasswordLevelLow:"Şifreniz Güvenli Değil , değiştirmeniz önerilir",
		PasswordLevelHigh:"Şifreniz En Üst Seviyede",
		PersonalInformation:"Kişisel Bilgiler",
		RealNameTip:"Bu çoğunlukla belirsiz girişlerdeki kimlik doğrulaması için kullanılır ve hesap başvurunuz için önemli bir belgedir",
		MobilePhonebinding:"Telefon ile bağlan",
		SecurityQuestionTip:"Önemli işlevleri kurmaya yardım et , Örneğin şifre yenileme ",
		Emailbinding:"Email ile bağlan",
		SecurityQuestion:"Güvenlik sorusu",
		NicknameTip:'Lütfen Nick Name',
		NicknameSet:'Nick Name belirlendi'
	},
	password:{
		ChangePassword:"Şifreyi Değiştir ",
		CurrentPassword:"Geçerli Şifre",
		CurrentPasswordTip:"Lütfen geçerli şifrenizi giriniz",
		NewPassword:"Yeni Şifre",
		NewPasswordTip:"Lütfen yeni şifrenizi giriniz",
		ConfirmPassword:"Şifreyi Doğrula",
		ConfirmPasswordTip:"Lütfen yeni şifrenizi tekrar giriniz ",
		ForgotPassword:"Şifrenizi mi unuttunuz?",
		PasswordsNotMatch:"Şifreler eşleşmiyor",
		PasswordChangeSuccess:"şifre değiştirildi",
		OldPasswordError:"Yanlış parola",
		NewPasswordSameAsOldPassword:"Yeni şifre eskisi ile aynı olmamalıdır.",
		SetPassword:'Şifre belirleyin'
	},
	forgot:{
		RecoverPassword:"Şifreyi Kurtar",
		RecoverPasswordTip:"Şifrenizi 3 yolu takip ederek geri alabilirsiniz. Eğer başka bir problem olursa，lütfen acilen müşteri destek servisimizle iletişime geçin",
		SecurityMobilePhone:"Telefon no ile",
		SecurityEmail:"Email ile",
		SecurityQuestion:"Güvenlik sorusu ile",
		UserName:"Kullanıcı adı",
		SecurityQuestion:"Güvenlik sorusu",
		SecurityAnswer:"Güvenlik Cevabı",
		SecurityAnswerTip:"Lütfen güvenlik cevabınızı girin",
		SecurityAnswerError:"Yanlış Güvenlik cevabı",
		NewPassword:"Yeni şifre",
		NewPasswordTip:"Lütfen yeni şifrenizi girin",
		ConfirmPassword:"Şifrenizi doğrulayın",
		NewPasswordAgainTip:"Yeni şifrenizi tekrar girin",
		PhoneTip:"Lütfen telefon numaranızı girin ",
		VerificationCode:"Doğrulama kodu",
		VerificationCodeTip:"Lütfen doğrulama kodunu giriniz",
		SendVerificationCode:"Doğrulama kodu gönder",
		EmialTip:"Lütfen Email'inizi giriniz",
		Confirmation:"Doğrula",
		PasswordsNotMatch:"Şifreler eşleşmiyor",
		PasswordChangeSuccess:"şifre değiştirildi",
		NotBoundPhone:"Cep Telefonu'na bağlanmadınız",
		NotBoundEmail:"E-postaya bağlanmadınız",
		NotSetQuestion:"Güvenlik Sorusu ayarlamadınız",
	},
	realName:{
		Name:"İsim",
		NameTip:"Lütfen gerçek isminizi giriniz",
		IDCard:"Kimlik Kartı No",
		IDCardTip:"Lütfen Kimlik kartı Numaranızı giriniz",
		SetRealnameSuccess:"Bilgileri başarıyla doğrulayın",
		ModifyTip:'Kimlik doğrulama bilgilerini değiştirin, lütfen müşteri hizmetleri merkezinden müşteri hizmetleri ile iletişime geçin',
		ReCertification:'yeniden sertifikalandırma',
		SetRealnameFail:'Kimlik doğrulama başarısız oldu, lütfen eşleşen kişisel bilgileri girin',
		MisMatch:'Kimlik doğrulama bilgileri eşleşmiyor, lütfen tekrar girin',
	},
	phone:{
		MobilePhonebinding:"Telefonunuzu bağlayın",
		MobilePhoneNumber:"Telefon numaranız",
		MobilePhoneNumberTip:"Lütfen Telefon numaranızı girin ",
		VerificationCode:"Doğrulama Kodu",
		VerificationCodeTip:"Lütfen doğrulama kodunu giriniz",
		SuccessTip:"Telefon bağlama durumu : ",
		BoundtoMobilephone:"Telefona bağlı",
		ChangetheMobilephone:"Telefonu değiştir",
		UnbindtheMobilephone:"Telefon ile bağlantıyı kes",
		Phonelossorabnormity:"Telefon kaybı veya başka bir anormallik?",
		MessageAuthenticationCode:"Doğrulama mesaj kodu",
		NewBindPhone:'Yeni bağlı cep telefonu',
		BindingNewPhone:'Yeni cep telefonunu bağla',
		Next:'Sonraki adım',
		CheckOldPhone:'Orijinal cep telefonunu doğrulayın',
		HadBindOther:'Telefon diğer hesaplara bağlı',
		PleaseCheckOldPhone:'Lütfen önce orijinal cep telefonu numarasını doğrulayın'
	},
	email:{
		Email:'Email',
		EmailTip:"Lütfen Email'inizi giriniz",
		Emailbinding:"Email Bağla",
		SuccessTip:"Email bağlama durumu: ",
		BoundtoEmail:"Email'e bağlı",
		ChangetheEmail:"Email'i Değiştir",
		UnbindtheEmail:"Email ile bağlantıyı kes",
		Emaillossorabnormity:"Email kaybı veya başka bir anormallik",
		UnbindingEmailSuccessfully:"E-postanın başarıyla Kaldirildi",
		EmailFormat:'E-posta formatı doğru değil'
	},
	question:{
		SecurityQuestion:"Güvenlik sorusu",
		SecurityAnswer:"Güvenlik cevabı",
		SecurityAnswerTip:"Lütfen güvenlik cevabınızı girin",
		ConfirmAnswer:"Cevabınızı doğrulayın",
		ConfirmAnswerTip:"Lütfen güvenlik cevabınızı tekrar girin",
		SetQuestionSuccess:"Güvenlik sorusu belirlendi",
		QuestionNotMatch:"Cevaplar eşleşmiyor",
		AnswerLength:'Cevap 40 harften az olmalı',
	},
	complaint:{
		ComplaintCon:'Hesap bilgilerinizi güvenlik bilgilerinizle sıfırlayamıyorsanız, destek ekibimize bttr-Support@wizardgames.cn E-Posta adresinden bazı bilgiler göndererek manuel sıfırlama talebinde bulunabilirsiniz. Manuel sıfırlama için istenilen bilgiler: Kimlik numaranız, ( Hesap kimlik doğrulamada kullanılan kimlik bilgileri) 2 ila 3 güncel ödeme kayıtları, dekontlar ve hesabınızla ilgili özel bilgiler. Tüm bilgiler ekibimiz tarafından 3-7 iş günü içerisinde kontrol edilecek ve yanıt almak istediğiniz E-posta adresinize manuel hesap sıfırlama sonucunu gönderecektir. '
	},
	charge:{
		OnlineBank:"Online Banka",
		RechargeAccount:"Tekrar doldur",
		ChoseGame:"Oyun ",
		ChoseServer:"Sunucu",
		ServerSlt:"Oynunuzu ve sunucu yerinizi seçin !",
		RechargeAmount:"Yeniden yükleme tutarı",
		AmountTip:"Diğer miktar",
		BanksTip:"Lütfen takip edilecek bankalardan birini seçiniz ",
		MoreBanks:"Daha fazla banka",
		Overview:"Genel kontrol",
		Game:"Oyun",
		Server:"Sunucu",
		Price:"Ödül",
		Confirmthepayment:"Ödemeyi doğrula",
		SuccessTip:"Tebrikler ! Tamamen doldurma başarılı",
		OrderInformation:"Sipariş bilgileri ",
		TopupGame:"Kupon oyunu",
		Rechargeserver:"Sunucuyu Yenile",
		Paymentmethod:"Ödeme yöntemi",
		TotalrechargeAmount:"Toplam Yeniden yükleme tutarı",
		Topupagain:"Tekrar kupon yükle ",
		RechargeHistory:"Yeniden yükleme geçmişi",
		GoldAmount:"{gold} Altın",
		MoneyAmount:"TRY {money}",
		PayWithWeixin:'Wechat QR kodunu tarayarak tamamlayın',
		TopupSuccessfully:"Başarıyla doldur",
		TopupProblems:"Şarjda karşılaşılan sorunla",
		ChoseAmount:"Şarj tutarınızı seçin",
		ChoseGameAndRegion:"Oyun ve sunucu konumunuzu seçin",
		ChoseChargeType:"Bir şarj yöntemi seçin",
		TopupFailTip:'Yüklenemedi, lütfen tekrar gönderin',
		TopupFailNeedService:"Yüklenemedi, lütfen Müşteri Hizmetleri ile iletişime geçin {msg}",
		OrderNumber:'Sipariş numarası',
		RedeemCode:'Kod Kullan',
		Topup:'Tamam',
		ConfirmThePayment:'Ödemeyi doğrula',
		TenAmount:"Yeniden yükleme miktarını özelleştirin( lütfen 10 'un katlarını giriniz )",
		Unknown:'Bilinmeyen',
		Unpaid:'Ödenmemiş',
		Recharging:'Yükleniyor',
		RechargeSuccessful:'Yükleme başarılı',
		RechargeFailed:'Yükleme Başarısız',
		CancelTheRecharge:'Yüklemeyi iptal et',
		Refunded:'Geri Ödendi',
		CancelTheRefund:'Geri ödemeyi iptal et',
		RefundFailed:'Geri ödeme başarısız',
		Refunding:'Geri ödeme yapılıyor',
		NewOrder:'Yeni Sipariş',
		StyleDeal:'Beklemede',
		Dealing:'İşleniyor',
		Expired:'Süresi Geçti',
		Checking:'İnceleniyor',
		Provider:'Ödeme kuruluşu'
	},
	chargeHistory:{
		LastWeek:"Geçen hafta",
		LastMonth:"Geçen ay",
		HistoricalRecharge:"Yeniden yükleme geçmişi",
		QueryRange:"Sorgu aralığı",
		Selectgames:"Oyunları seçiniz",
		Pleaseselectagame:"Lütfen bir oyun seçiniz",
		Inquire:"Soruştur",
		Time:"Zaman",
		Account:"Hesap",
		GameServer:"oyun sunucusu",
		Paymentmethod:"ödeme yöntemi",
		PaymentAmount:"ödeme miktarı",
		Status:"Durum",
		Totalamount:"Toplam Yeniden yükleme miktarı",
		Totalitems:"Toplam {items} öğeleri",
	},
	login:{
		Login:"Wooduan Geçiş girişleri",
		AccountLabel:"Kullanıcı adı / Telefon numarası / Email",
		PasswordLabel:"Şifre",
		ConfirmPassword:'Şifreyi Onayla',
		ConfirmPasswordLabel:'Şifreyi doğrula',
		LoginBtn:"Şimdi giriş yap",
		RegisterBtn:'Hemen Kaydol',
		RegisterLink:"Hesabınız yokmu? Hemen Kaydol !",
		LoginLink:'Bu isimde hesap var . Giriş yapmak için tıklayın',
		ForgotLink:"Şifremi unuttum ",
		QuickLogin:"Hızlı Giriş",
		Register:'Wooduan Geçiş kaydı',
		RecoverByPhone:"Parolanızı Security Mobile ile kurtarın",
		RecoverByQuestion:"Şifrenizi Güvenlik Sorusu ile kurtarın",
		RecoverByEmail:"Parolanızı Güvenlik E-postası ile kurtarın",
		Phone:"Cep telefonu numarası",
		UserName:"Kullanıcı adı",
		ResetPassword:"Şifreyi yenile",
		RecoverByOther:"Şifrenizi diğer yöntemlerle kurtarın",
		SecurityEmail:"Güvenlik E-postası",
		SecurityQuestion:'Güvenlik Sorusu',
		SecurityAnswer:'Güvenlik cevabı',
		PhoneAccountTip:'Lütfen kullanıcı adınızı veya cep telefonunuzu giriniz.',
		PasswordTip:'Şifrenizi giriniz Lütfen',
		PhoneNotReged:'Bu cep telefonu hiç kayıt edilmedi',
		AccountNotReged:'Bu kullanıcı adı hiç kaydedilmemiş',
		LoginFail:'Giriş yapamadı,lütfen tekrar giriş yapın',
		RegSuccess:'Başarılı bir şekilde giriş yapın, lütfen giriş yapın',
		PhonwHasReged:'Bu cep telefonu zaten kayıtlı',
		AccountHasReged:'Bu kullanıcı adı zaten kayıtlı',
		RegFail:'Oturum açılamadı, lütfen tekrar gönderin',
		PasswordErr:'6-16 Harfli Şifrede, En Az 1 Harf veya Rakam Bulunmalıdır',
		AccountErr:'4-18 Harfli Kullanıcı Adında Sadece Latin Harfleri Kullanılabilir',
		EmailHasReged:'Email zaten kayıtlı',
		RegAccountTip:'Kullanıcı Adı Gir',
	},
	third:{
		RemoveBound:'Eşleştirme',
   		UnbindSuccess:'Eşleştirme Başarılı',
    	ThirdAccountTip:'Aşağıdaki Diğer Girişle De Eşleştirebilirsiniz, Eşleştirdikten Sonra Diğer Girişlerle Hızlıca Giriş Yapabilirsiniz',
	},
	bind: {
		head:'Hesabı Eşleştir',
        tip:'Lütfen Hesap Adını/Telefonu/Email İle Eşleştir',
		bind:'Hemen Eşleştir',
		or:'Hemen Eşleştir',
        auto:'Otomatik Hesap Oluştur',
        user:'Kullanıcı Adı',
        password:'Şifre',
                noAccount:'Hesabın Yoksa, Hemen Üye Ol',
                hasAccount:'Hesabın Varsa, Hemen Eşleştir',
                regHead:'Kayıt Ol',
                regTip:'Lütfen Kayıt Bilgilerini Giriniz',
                confirm_password:'Şifreyi Onayla',
                email:'Email',
                phone:'Telefon Numarası',
                emailCode:'Email Onay Kodu',
                phoneCode:'Telefon Onay Kodu',
                getCode:'Onay Kodunu Al',
                retry:'Tekrar Dene',
                submit:'Onayla', 
                accountTip:'Kullanıcı Adını Gir',
                passwordTip:'Şifreni Gir',
                passwordErr:'Şifre Biçim Hatası, Şifre 6-16 Harf Aralığında Olmalı En Az Bitane Büyük Hard Yada Rakam Olmalı, Özel Karakter İçermemeli',
                confirmTip:'İki Şifre Eşleşmiyor',
                phoneTip:'Telefon Numaranı Gir',
                emailTip:'Emaili Gir',
                phoneErr:'Telefon Numarası Yalnış',
                emailErr:'Email Yalnış',
                codeTip:'Onay Kodunu Giriniz',												               
		bindErr:'Bağlama başarısız oldu, lütfen daha sonra tekrar deneyin',
		confirm:'belirlemek',
		cancel:'iptal edildi',
		return:'Sayfasına geri dön',
		PhonwHasReged:'Bu cep telefonu zaten kayıtlı',
		AccountHasReged:'Bu kullanıcı adı zaten kayıtlı',
		VerificationCodeError:'Yanlış doğrulama kodu',
		EmailHasReged:'Email zaten kayıtlı',
		ErrorSendingEmail:'E-posta doğrulama kodunu gönderirken hata oluştu, lütfen e-postanızı kontrol edin.',
		ErrorSendingMessage:'Mesaj doğrulama kodunu gönderirken hata oluştu, lütfen telefon numaranızı kontrol edin.',
		ParamErr:'Parametre hatası'
	}

}

